import { SocialHistoryQuestion } from 'components/medicalHistory/types/types';

export const SOCIAL_HISTORY_QUESTIONS: SocialHistoryQuestion = {
  tobaccoUsedInLast12Months: {
    name: 'Have you used tobacco products in the last 12 months?',
    option: Object.freeze([
      { label: 'No', value: 'No' },
      { label: 'One to ten', value: '1 - 10 times' },
      { label: 'Eleven plus', value: '11+ times' },
    ]),
  },
  alcoholConsumedInLast12Months: {
    name: 'How many times in the last 12 months did you have more than 4-5 drinks?',
    option: Object.freeze([
      { label: 'Zero to one', value: '0 - 1 times' },
      { label: 'Two to ten', value: '2 - 10 times' },
      { label: 'Eleven plus', value: '11+ times' },
    ]),
  },
  haveYouEverPutInAnAdvanceCarePlan: {
    name: 'Have you put in place an Advanced Care Plan? (e.g. any of the following: Living Will, Surrogate Decision Maker, DNR, Durable Power of Attorney)',
    option: Object.freeze([
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' },
      { label: 'Decline to answer', value: 'Decline to answer' },
    ]),
  },
  hadOneOrMoreMinorOrFallsInLast12Months: {
    name: 'In the last 12 months, have you either:\n - Had two or more minor falls\n - One or more falls with an injury',
    option: Object.freeze([
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' },
    ]),
  },
};
